import { Injectable } from '@angular/core';
import { BaseOptionsApiService } from '@kinet-open-network/client/core/api-client';
import { AbilitySubject } from '@kinet-open-network/shared/data-access/model';
import { InvoiceOptions } from '../models/invoice-options.model';

@Injectable({
  providedIn: 'root',
})
export class InvoiceOptionsService extends BaseOptionsApiService<InvoiceOptions> {
  override get endpoint(): string {
    return '/invoicing/options';
  }
  override model = InvoiceOptions;

  override subject = 'Invoice' as AbilitySubject;
}
